<template>
  <div class="section haze full-height">
    <span hidden>{{ clientSecret }}</span>
    <div class="wrapper">
      <div class="wrapper w-container">
        <div class="middle">
          <h5 class="green left">
            <strong>Step 3 of 3 | </strong
            ><span
              ><strong class="bold-text-2">Payment Information</strong></span
            >
          </h5>
        </div>
      </div>
      <div class="middle" />
      <div class="contact-v2">
        <div
          id="w-node-0158c67f9bb1-59de2a59"
          class="contact-v2-info border-side"
        >
          <h3 class="volk green">Account Owner Information</h3>
          <div v-if="hasError" class="w-form-fail">
            <div>Oops! Something went wrong while submitting the form.</div>
            <div v-if="stripeError">{{ stripeError }}</div>
          </div>
          <div class="full-width w-form">
            <form
              id="Contact-Form-1"
              name="email-form"
              data-name="Email Form"
              class="contact-form"
              autocomplete="on"
            >
              <div id="w-node-0158c67f9bb6-59de2a59">
                <label for="fname">First name *</label
                ><input
                  id="fname"
                  v-model="accountOwner.first_name.$model"
                  type="text"
                  class="input w-input"
                  maxlength="256"
                  name="given-name"
                  autocomplete="given-name"
                  placeholder="First Name"
                />
              </div>
              <div id="w-node-72e264aff241-59de2a59">
                <label for="lname">last name *</label
                ><input
                  id="lname"
                  v-model="accountOwner.last_name.$model"
                  type="text"
                  class="input w-input"
                  maxlength="256"
                  name="family-name"
                  autocomplete="family-name"
                  placeholder="Last Name"
                />
              </div>
              <div id="w-node-1240bc9aacb0-59de2a59">
                <label for="email">EMAIL ADDRESS *</label
                ><input
                  id="email"
                  v-model="accountOwner.email.$model"
                  type="email"
                  class="input w-input"
                  maxlength="256"
                  name="email"
                  autocomplete="email"
                  placeholder="Email Address"
                  required=""
                />
              </div>
              <div id="w-node-300e07e49617-59de2a59">
                <label for="phone">Phone number *</label
                ><input
                  id="phone"
                  v-model="accountOwner.phone.$model"
                  type="email"
                  class="input w-input"
                  maxlength="256"
                  name="tel"
                  autocomplete="tel"
                  placeholder="Phone Number"
                  required=""
                />
              </div>
              <div id="w-node-0158c67f9bba-59de2a59">
                <label for="cardNumber">Credit card number *</label>
                <div
                  id="cardNumber"
                  ref="cardNumber"
                  type="text"
                  class="input w-input"
                  maxlength="256"
                  name="cc-number"
                  autocomplete="cc-number"
                  placeholder="**** **** **** ****"
                  required=""
                />
              </div>

              <div class="div-block-6">
                <div>
                  <label for="cardExpiry">Exp Date*</label>
                  <div
                    id="cardExpiry"
                    ref="cardExpiry"
                    type="text"
                    class="input w-input"
                    maxlength="256"
                    name="cc-exp"
                    autocomplete="cc-exp"
                    placeholder="05 24"
                  />
                </div>

                <div>
                  <label for="cardCvc">SECURITY CODE*</label>
                  <div
                    id="cardCvc"
                    ref="cardCvc"
                    type="text"
                    class="input w-input"
                    maxlength="256"
                    name="cc-csc"
                    autocomplete="cc-csc"
                    placeholder="Security Code"
                  />
                </div>
              </div>
              <div>
                <label for="coupon">Coupon</label
                    >
                <div class="coupon-container">
                  <div>
                    <input
                      id="coupon"
                      v-model="coupon"
                      type="text"
                      class="input w-input"
                      maxlength="256"
                    />
                  </div>
                  <button @click.prevent="applyCoupon" :loading="couponLoading">APPLY</button>
                </div>
                <span class="coupon-message" :class="{error: couponError }" v-if="couponMessage">{{ couponMessage }}</span>
              </div>
            </form>
            <div class="form-success w-form-done">
              <div>Thank you! Your submission has been received!</div>
            </div>
            <div class="form-error w-form-fail" style="display: none">
              <div>Oops! Something went wrong while submitting the form.</div>
            </div>
          </div>
        </div>
        <div
          id="w-node-202f93e42675-59de2a59"
          class="contact-v2-info-cart"
          style="align-items: flex-start;justify-content: flex-start;margin-top: 71px;"
        >
          <div id="w-node-0158c67f9bb6-59de2a59">
            <label for="fname">Billing Frequency</label
            ><select v-model="interval" class="input w-input">
              <option v-for="i in intervals" :value="i.value">
                {{ i.name }}
              </option>
            </select>
          </div>
          <h3 class="volk green">Payment Breakdown</h3>
          <div class="full-width w-form">
            <form
              id="Contact-Form-1"
              name="email-form"
              data-name="Email Form"
              class="receipt-blue-box"
            >
              <div v-for="patient in patients" :key="patient.id">
                <label
                  v-if="patient.plan"
                  id="w-node-341224005ca9-59de2a59"
                  for="name"
                  class="text-grey cart-text"
                  >{{ patient.first_name }} {{ patient.last_name }}</label
                >
                <div
                  v-if="patient.plan"
                  id="w-node-202f93e4267a-59de2a59"
                  class="pull-left"
                >
                  <label class="left-not-bold">{{
                    patient.plan.display_name
                  }}</label>
                  <label
                    v-for="addon in patient.addons"
                    :key="addon.ada_code"
                    class="left-not-bold"
                    >{{ addon.display_name }}</label
                  >
                  <label
                    v-for="discount in patient.discounts"
                    :key="discount.code"
                    class="left-not-bold"
                    >{{ discount.name }}</label
                  >
                </div>
                <div v-if="patient.plan" id="w-node-202f93e4267e-59de2a59">
                  <label
                    class="bold-right"
                    v-if="
                      patient.plan.interval === 'year' &&
                      patient.plan.annual_base_price
                    "
                    >${{ patient.plan.annual_base_price | toMonetary }}</label
                  >
                  <label
                    class="bold-right"
                    v-else-if="
                      patient.plan.interval === 'semi-annually' &&
                      patient.plan.semiannual_base_price
                    "
                    >${{
                      patient.plan.semiannual_base_price | toMonetary
                    }}</label
                  >
                  <label class="bold-right" v-else
                    >${{
                      (patient.plan.base_price * intervalMultiplier)
                        | toMonetary
                    }}</label
                  >
                  <label
                    v-for="addon in patient.addons"
                    :key="addon.ada_code"
                    class="bold-right"
                  >
                    <span
                      v-if="
                        patient.plan.interval === 'year' &&
                        addon.annual_base_price
                      "
                    >
                      ${{ addon.annual_base_price | toMonetary }}
                    </span>
                    <span
                      v-else-if="
                        patient.plan.interval === 'semi-annually' &&
                        addon.semiannual_base_price
                      "
                    >
                      ${{ addon.semiannual_base_price | toMonetary }}
                    </span>
                    <span v-else>
                      ${{
                        (addon.base_price * intervalMultiplier) | toMonetary
                      }}
                    </span>
                  </label>
                  <label
                    v-for="discount in patient.discounts"
                    :key="discount.consumer_code"
                    class="bold-right"
                    >-${{
                      (discount.appropriation_amount * intervalMultiplier)
                        | toMonetary
                    }}</label
                  >
                </div>
              </div>
              <div v-if="isCouponFreeMonths">
                <label for="" style="color: green">Charges will start <span style="font-weight: bolder;">{{ chargesStartAt }}</span></label>
              </div>
              <div
                id="w-node-c9ac6dc05b64-59de2a59"
                class="div-block-5 my-20"
              />
              <div id="w-node-d5731c70613e-59de2a59">
                <label for="email" class="left-not-bold pull-left"
                  >Enrollment Fee X{{ patients.length }}</label
                >
              </div>
              <div>
                <label
                  for="email"
                  class="bold-right"
                  v-if="
                    !company.company.waive_enrollment_fee_on_annual_payments ||
                    interval === 'month'
                  "
                  >${{ enrollmentFee | toMonetary }}</label
                >
                <label
                  for="email"
                  class="bold-right"
                  style="font-size: 11px; color: green"
                  v-else-if="
                    interval === 'semi-annually' &&
                    company.company.waive_enrollment_fee_on_annual_payments
                  "
                  >Waived for Semi-Annual Payments</label
                >
                <label
                  for="email"
                  class="bold-right"
                  style="font-size: 11px; color: green"
                  v-else-if="
                    interval === 'year' &&
                    company.company.waive_enrollment_fee_on_annual_payments
                  "
                  >Waived for Annual Payments</label
                >
              </div>
              <div id="w-node-d5731c70613e-59de2a59" v-if="couponObj">
                <label for="discount" class="left-not-bold pull-left"
                  >Coupon Discount</label
                >
                <label
                  for="email"
                  class="bold-right"
                  style="color: green"
                  >-${{ couponObj.amount|toMonetary }}</label
                >
              </div>
              <div id="w-node-202f93e42682-59de2a59" class="dark-line my-20" />
              <div id="w-node-d1926997240e-59de2a59">
                <label for="email" class="left-not-bold pull-left"
                  >Today&#x27;s Total</label
                >
              </div>
              <div>
                <label
                  for="email"
                  class="bold-right"
                  v-if="
                    interval === 'month' ||
                    !company.company.waive_enrollment_fee_on_annual_payments
                  "
                  >${{ (todaysTotal) | toMonetary }}</label
                >
                <label for="email" class="bold-right" v-else
                  >${{ (todaysTotal) | toMonetary }}</label
                >
              </div>
            </form>
            <div class="form-success w-form-done">
              <div>Thank you! Your submission has been received!</div>
            </div>
            <div class="form-error w-form-fail" style="display: none">
              <div>Oops! Something went wrong while submitting the form.</div>
            </div>
          </div>
          <h3 class="price">
            {{ intervalDisplay }} Recurring Total
            <span class="text-span">${{ theTotal | toMonetary }}</span>
          </h3>
        </div>
        <div id="w-node-6645abe4d7c5-59de2a59" class="toc-block w-form">
          <form
            id="email-form"
            name="email-form"
            data-name="Email Form"
            class="form"
          >
            <label class="w-checkbox checkbox-field">
              <input
                id="checkbox"
                v-model="accountOwner.terms.$model"
                type="checkbox"
                name="checkbox"
                data-name="Checkbox"
                required=""
                :disabled="!cardVerified"
                class="w-checkbox-input checkbox"
                @click="agree"
              /><span class="tac w-form-label"
                >I Agree to the terms and conditions</span
              ></label
            >
            <div class="toc-box">
              <h6>Terms and Conditions</h6>
              <p>{{ company.terms }}</p>
            </div>
          </form>
          <div class="w-form-done">
            <div>Thank you! Your submission has been received!</div>
            <div />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Util from "../../helpers/Util";
import PaymentRest from "../../rest/PaymentRest";

export default {
  name: "SignupInformation",
  filters: {
    toMonetary: function (value) {
      return Util.ConvertRealToMonetary(value);
    },
    toRewards: function (plan) {
      return (plan.rewards * (12 / plan.frequency)).toFixed(0);
    },
  },
  props: {
    patients: {
      type: Array,
      required: true,
      default: null,
    },
    total: {
      type: Number,
      required: true,
      default: 0,
    },
    enrollmentFee: {
      type: Number,
      required: true,
      default: 0,
    },
    stripeAccount: {
      type: String,
      default: "",
    },
    clientSecret: {
      type: String,
      default: "",
    },
    accountOwner: {
      type: Object,
      default: null,
    },
    company: {
      type: Object,
      default: null,
    },
    cardDetails: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      stripeError: "",
      interval: "month",
      setupIntent: null,
      coupon: null,
      couponMessage: null,
      couponError: false,
      couponApplied: false,
      couponObj: null,
      couponLoading: false,
    };
  },
  computed: {
    intervals() {
      const intervals = [
        // { value: "month", name: "Monthly" },
        // { value: "semi-annually", name: "Semi-Annually" },
        // { value: "year", name: "Annually" },
      ];

      const anyPlanNoSemiAnnual = this.patients.find((patient) => {
        return patient.plan.semiannual_base_price === 0;
      });

      console.log(
        `Suppress?: ${this.company.company.suppress_monthly_payment_option}`
      );

      // If not suppressed show all payment options
      if (!this.company.company.suppress_monthly_payment_option) {
        intervals.push({ value: "month", name: "Monthly" });
        intervals.push({ value: "year", name: "Annually" });
        intervals.push({ value: "semi-annually", name: "Semi-Annually" });
      } else {
        // if suppressed is enabled show only semi if it has values.
        if (!anyPlanNoSemiAnnual) {
          intervals.push({ value: "semi-annually", name: "Semi-Annually" });
          this.interval = "year";
        } else {
          this.interval = "year";
        }

        // Annual is always there.
        intervals.push({ value: "year", name: "Annually" });
      }

      return intervals;
    },
    cardVerified: function () {
      if (
        this.cardDetails.number === true &&
        this.cardDetails.cvc === true &&
        this.cardDetails.expiry === true
      ) {
        return true;
      } else {
        return false;
      }
    },
    hasError() {
      if (this.stripeError !== "") {
        return true;
      } else if (this.accountOwner.$error) {
        return true;
      } else {
        return false;
      }
    },
    intervalDisplay() {
      if (this.interval === "year") {
        return "Annually";
      } else if (this.interval === "semi-annually") {
        return "Semi-Annually";
      }

      return "Monthly";
    },
    intervalMultiplier() {
      if (this.interval === "year") {
        return 12;
      } else if (this.interval === "semi-annually") {
        return 6;
      }

      return 1;
    },
    subscribers() {
      return this.patients.map((patient) => {
        const p = { ...patient };
        patient.plan.interval = this.interval;

        return p;
      });
    },
    todaysTotal () {
      let couponAmount = 0
      if (this.couponObj) {
        couponAmount = this.couponObj.amount;
      }

      if (this.interval === 'month' || !this.company.company.waive_enrollment_fee_on_annual_payments) {
        if (this.isCouponFreeMonths) {
          return this.enrollmentFee - couponAmount;
        }
        return this.theTotal + (this.enrollmentFee - couponAmount);
      } else {
        return this.theTotal - couponAmount;
      }
    },
    isCouponFreeMonths () {
      if (this.couponObj) {
        return this.couponObj.free_months > 0;
      }

      return false;
    },
    chargesStartAt () {
      if (this.isCouponFreeMonths) {
        return moment().add(this.couponObj.free_months, 'months').format("MM/DD/YYYY");
      }

      return moment();
    },
    theTotal() {
      const totalPlan = this.subscribers.reduce((sum, patient) => {
        if (patient.plan) {
          if (
            patient.plan.interval === "year" &&
            patient.plan.annual_base_price
          ) {
            return sum + patient.plan.annual_base_price;
          } else if (
            patient.plan.interval === "semi-annually" &&
            patient.plan.semiannual_base_price
          ) {
            return sum + patient.plan.semiannual_base_price;
          } else {
            if (patient.plan.interval === "semi-annually") {
              return sum + patient.plan.base_price * 6;
            } else if (patient.plan.interval === "year") {
              return sum + patient.plan.base_price * 12;
            }
            return sum + patient.plan.base_price;
          }
        } else {
          return sum + 0;
        }
      }, 0);
      const totalAddons = this.subscribers.reduce((sum, patient) => {
        if (patient.plan) {
          const totalAddons = patient.addons.reduce((sum, addon) => {
            if (
              patient.plan.interval === "semi-annually" &&
              addon.semiannual_base_price
            ) {
              return sum + addon.semiannual_base_price;
            } else if (
              patient.plan.interval === "year" &&
              addon.semiannual_base_price
            ) {
              return sum + addon.annual_base_price;
            } else {
              if (patient.plan.interval === "semi-annually") {
                return sum + addon.base_price * 6;
              } else if (patient.plan.interval === "year") {
                return sum + addon.base_price * 12;
              }
              return sum + addon.base_price;
            }
          }, 0);
          return sum + totalAddons;
        } else {
          return sum + 0;
        }
      }, 0);
      const totalDiscount = this.subscribers.reduce((sum, patient) => {
        if (patient.plan) {
          const totalDiscounts = patient.discounts.reduce((sum, disocunt) => {
            return (
              sum + disocunt.appropriation_amount * this.intervalMultiplier
            );
          }, 0);
          return sum + totalDiscounts;
        } else {
          return sum + 0;
        }
      }, 0);
      return totalPlan + totalAddons - totalDiscount;
    },
  },
  mounted() {
    this.stripe = Stripe(process.env.MIX_STRIPE_KEY, {
      stripeAccount: this.stripeAccount,
    });

    if (this.stripe === undefined) {
      console.log("Failed to load stripe library!");
    } else {
      this.elements = this.stripe.elements();
      this.cardCvc = this.elements.create("cardCvc");
      this.cardExpiry = this.elements.create("cardExpiry");
      this.cardNumber = this.elements.create("cardNumber");
      this.cardCvc.mount(this.$refs.cardCvc);
      this.cardExpiry.mount(this.$refs.cardExpiry);
      this.cardNumber.mount(this.$refs.cardNumber);

      this.cardNumber.addEventListener("change", (event) => {
        this.toggleError(event);
        this.cardDetails.number = !!event.complete;
      });
      this.cardExpiry.addEventListener("change", (event) => {
        this.toggleError(event);
        this.cardDetails.expiry = !!event.complete;
      });
      this.cardCvc.addEventListener("change", (event) => {
        this.toggleError(event);
        this.cardDetails.cvc = !!event.complete;
      });
    }
  },
  methods: {
    toggleError: function (event) {
      if (event.error) {
        this.stripeError = event.error.message;
      } else {
        this.stripeError = "";
      }
    },
    agree() {
      if (this.cardVerified) {
        this.confirm();
      } else {
        this.accountOwner.$touch();
      }
    },
    async applyCoupon() {
      this.couponLoading = true;
      const response = await PaymentRest.ApplyCoupon({
        'coupon_code': this.coupon
      });
      this.couponLoading = false;

      if (response.data.success) {
        this.couponMessage = 'Coupon applied.';
        this.couponError = false;
        this.couponApplied = true;
        this.couponObj = response.data.coupon;
        this.$emit('couponApplied', this.couponObj);
      } else {
        this.couponError = true;
        this.couponMessage = response.data.message;
      }
    },
    async confirm() {
      console.log("confirming card details...");
      this.$emit("confirmingCard");

      if (this.setupIntent) {
        this.$emit("complete", this.setupIntent.payment_method);
      } else {
        const { setupIntent, error } = await this.stripe.confirmCardSetup(
          this.clientSecret,
          {
            payment_method: {
              card: this.cardNumber,
              billing_details: {
                name: this.accountOwner.first_name.$model,
                email: this.accountOwner.email.$model,
                phone: this.accountOwner.phone.$model,
              },
            },
          }
        );
        if (error) {
          this.stripeError = error.message;
          this.$emit("failure");
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
          this.accountOwner.terms.$model = false;
        } else {
          // Handle 3D Secure if necessary
          if (setupIntent.status === "requires_action") {
            const { error: confirmationError } = await this.stripe.handleCardAction(
              setupIntent.client_secret
            );

            if (confirmationError) {
              this.stripeError = confirmationError.message;
              this.$emit("failure");
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
              return;
            }

            // Retry the setup intent after successful 3D Secure authentication
            const { setupIntent: newSetupIntent, error: retryError } = await this.stripe.confirmCardSetup(
              this.clientSecret
            );

            if (retryError) {
              this.stripeError = retryError.message;
              this.$emit("failure");
              return;
            }

            this.$emit("complete", newSetupIntent.payment_method);
            this.setupIntent = newSetupIntent;
          } else {
            this.$emit("complete", setupIntent.payment_method);
            this.setupIntent = setupIntent;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
.coupon-message {
  font-size: 11px;
  font-weight: 600;
  color: green;
  &.error {
    font-size: 11px;
    font-weight: 600;
    color: red;
  }
}
.coupon-container {
  display: flex;
  gap: 10px;

  button {
    background: #4b9fe1;
    color: #fff;
    font-size: 12px;
    border-radius: 8px;
    padding: 0 2em;
  }
}
</style>
